import { call, put, select, takeLatest } from 'redux-saga/effects'
import {
  resetSearchConfigAndStartLoading,
  setSearchError,
  setSearchResult,
  setSuccessSearchId,
} from './searchContactsSlice'
import { callApi } from '@/shared/tools/apiSagaHelper'
import { selectSearchContacts } from './searchContactsSelectors'
import { selectAuthData } from '@/containers/Login/AuthSelectors'
import * as Sentry from '@sentry/react'

export const searchContactsActions = {
  TRIGGER_SEARCH: 'TRIGGER_SEARCH',
}

export function* triggerSearch({ redirectWhenSingleResult }) {
  try {
    const { phone } = yield select(selectSearchContacts)
    yield put(resetSearchConfigAndStartLoading())
    const { loaderRoutes } = yield select(selectAuthData)
    const url = loaderRoutes['zoho-search-client'] || ''
    const endpoint = url + '?useBroadcast=1&phone=' + encodeURIComponent(phone)
    const result = yield call(callApi, {
      endpoint,
      method: 'GET',
    })
    if (result.id) {
      yield put(setSuccessSearchId(result.id))
      if (result.zoho_result?.length === 1) {
        redirectWhenSingleResult(result.zoho_result[0])
        return
      }
      if (result.zoho_result?.length > 1) {
        yield put(setSearchResult(result.zoho_result))
        return
      }
    }
    if (import.meta.env.PROD) {
      Sentry.captureException(result, { extra: { context: 'triggerSearchSaga' } })
    }
  } catch (error) {
    if (import.meta.env.PROD) {
      Sentry.captureException(error, { extra: { context: 'triggerSearchSagaError' } })
    }
    yield put(setSearchError(error.responseData?.message || 'An error occurred while searching contacts'))
  }
}

export default function* searchContactsSagas() {
  yield takeLatest(searchContactsActions.TRIGGER_SEARCH, triggerSearch)
}
